var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9501_5021)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#6C757E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8477 26.269C48.8103 26.033 48.4317 23.913 46.8957 22.365C45.353 20.8557 43.225 20.4823 42.9877 20.445C42.6717 20.393 42.349 20.4597 42.0783 20.6277C41.9837 20.6863 40.593 21.557 37.8477 23.8783C39.2597 24.377 41.085 25.2423 42.565 26.6903C44.0503 28.1437 44.9383 29.9317 45.4477 31.3183C47.741 28.6383 48.6037 27.281 48.661 27.1877C48.8317 26.9143 48.8983 26.5877 48.8477 26.269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2665 25.9639C33.8359 27.2545 32.1705 28.8225 30.2639 30.7159C22.1799 38.7425 20.0599 41.9519 19.9732 42.0839C19.8519 42.2705 19.7785 42.4852 19.7612 42.7065L19.3359 48.1345C19.3065 48.5239 19.4465 48.9052 19.7225 49.1812C19.9732 49.4319 20.3132 49.5719 20.6665 49.5719C20.6999 49.5719 20.7345 49.5719 20.7692 49.5679L26.2372 49.1465C26.4572 49.1292 26.6692 49.0585 26.8545 48.9399C26.9879 48.8545 30.2185 46.7492 38.3012 38.7239C40.2505 36.7879 41.8585 35.1025 43.1745 33.6612C42.9732 32.7959 42.2705 30.3265 40.5012 28.5972C38.7065 26.8412 36.1252 26.1532 35.2665 25.9639Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9501_5021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioEdit);
export default __webpack_public_path__ + "static/media/audio-edit.9c035b35a05934f14248f022c21b630e.svg";
export { ForwardRef as ReactComponent };